import { connect } from 'react-redux';

import PartnerStatistics from '../../components/sider/partner-statistics';

export default connect()(PartnerStatistics);



// WEBPACK FOOTER //
// ./containers/sider/partner-statistics.js